import { render } from "./DialogTestNameWithCheckbox.vue?vue&type=template&id=2be81872&scoped=true"
import script from "./DialogTestNameWithCheckbox.vue?vue&type=script&lang=js"
export * from "./DialogTestNameWithCheckbox.vue?vue&type=script&lang=js"

import "./DialogTestNameWithCheckbox.vue?vue&type=style&index=0&id=2be81872&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be81872"]])

export default __exports__